<template>
  <div class="detail">
    <div class="card">
      <div class="title">拜访人信息</div>
      <div class="panel flex flex-vc border-b">
        <img class="img" :src="data.photoImg ? data.photoImg : data.avatar" alt="" @click="previewImg(data.photoImg)" />
        <div class="info">
          <div class="name">{{ data.initiatorName }}</div>
          <span class="phone" @click="getMobile(data, data.isShowMobile)">{{ data.isShowMobile ? data.noMobile :
          data.visitorPhone }}</span>
          <van-icon class="phone" style="margin-left: 3px;" @click="getMobile(data, data.isShowMobile)"
            v-if="!data.isShowMobile" name="eye-o" />
          <van-icon class="phone" style="margin-left: 3px;" @click="getMobile(data, data.isShowMobile)"
            v-if="data.isShowMobile" name="closed-eye" />
        </div>
      </div>
      <div class="cell" style="padding: 1rem 0.6rem">
        <span class="headline">预约时间</span>
        <span style="color: #454f63; font-size: 0.75rem">{{ data.time }}</span>
      </div>
    </div>
    <div class="person-list" v-if="personList.length > 1">
      <div class="person-header">
        <span>同行人员</span>
      </div>
      <div class="person-item flex flex-vc" v-for="(item, index) in personList.slice(1)" :key="index">
        <div class="person-avatar">
          <img :src="item.photoImg" />
        </div>
        <div class="person-info flex-1">
          <div class="person-name">{{ item.visitorName }}</div>
          <span @click="getTeacherOrParentMobile(item, item.isShowMobile)" class="person-phone">{{ item.isShowMobile ?
          item.noMobile : item.visitorPhone }}</span>

          <van-icon class="person-phone" style="margin-left: 3px;"
            @click="getTeacherOrParentMobile(item, item.isShowMobile)"
            v-if="!item.isShowMobile && item.name != '该学生未绑定家长'" name="eye-o" />
          <van-icon class="person-phone" style="margin-left: 3px;"
            @click="getTeacherOrParentMobile(item, item.isShowMobile)" v-if="item.isShowMobile" name="closed-eye" />
        </div>
      </div>
    </div>
    <!-- 其他信息 -->
    <div class="card">
      <div class="title">其他信息</div>
      <div class="panel">
        <div class="cell">
          <span class="headline">所属单位</span>
          <span>{{ data.affiliatedUnit }}</span>
        </div>
        <div class="cell">
          <span class="headline">车牌号</span>
          <span>{{ data.carNumber }}</span>
        </div>
        <div class="cell">
          <span class="headline">预约事由</span>
          <span>{{ data.visitorGoal }}</span>
        </div>
        <div class="cell">
          <span class="headline">备注</span>
          <span>{{ data.remark }}</span>
        </div>
      </div>
    </div>


    <div class="card" v-if="nucleStatus">
      <div class="title">
        <span>预约人及同行人健康码</span>
        <span v-if="!(data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 0))"> :
          暂无</span>
      </div>
      <div class="panel_1" v-if="data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 0)">
        <img class="img_1" @click="previewImg(img.imgUrl)"
          v-for="img in data.visitorHealthCertificate.filter(x => x.type == 0)" :key="img.imgUrl" :src="img.imgUrl"
          alt="">
      </div>
      <div class="title">
        <span>预约人及同行人行程码</span> <span
          v-if="!(data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 1))"> : 暂无</span>
      </div>
      <div class="panel_1" v-if="data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 1)">
        <img class="img_1" @click="previewImg(img.imgUrl)"
          v-for="img in data.visitorHealthCertificate.filter(x => x.type == 1)" :key="img.imgUrl" :src="img.imgUrl"
          alt="">
      </div>
      <div class="title">
        <span>预约人及同行人核酸检测证明</span> <span
          v-if="!(data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 2))"> : 暂无</span>
      </div>
      <div class="panel_1" v-if="data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 2)">
        <img class="img_1" @click="previewImg(img.imgUrl)"
          v-for="img in data.visitorHealthCertificate.filter(x => x.type == 2)" :key="img.imgUrl" :src="img.imgUrl"
          alt="">
      </div>
    </div>

    <!-- 审批信息 -->
    <div class="card" v-if="data.busAuditLevelList.length > 0">
      <div class="title">审批信息</div>
      <div class="panel">
        <van-steps direction="vertical">
          <van-step v-for="item in data.busAuditLevelList" :key="item.id">
            <!-- 自定义图标 -->
            <template #active-icon>
              <van-icon :name="['fail', 'success', 'cross'][item.auditStatus]"
                :class="['fail', 'success', 'cross'][item.auditStatus]" />
            </template>
            <template #inactive-icon>
              <van-icon :name="['fail', 'success', 'cross'][item.auditStatus]"
                :class="['fail', 'success', 'cross'][item.auditStatus]" />
            </template>
            <div :class="['fail_text', 'success_text', 'cross_text'][item.auditStatus]">
              <span>{{ item.name }} </span><span>{{
          ["待审批", "已通过", "已驳回", "拜访完成", "正在审批"][
          item.auditStatus
          ] || "暂无审批状态"
        }} </span>
              <span v-if="item.createdTime">{{ item.createdTime || "暂无审批时间" }}</span>
              <p v-if="item.remark">{{ ` 备注 : ${item.remark || '暂无备注'}` }}</p>
            </div>
          </van-step>
        </van-steps>
      </div>
    </div>



    <div class="btn-group">
      <van-row :gutter="20" class="btn-wrap" v-if="data.auditStatus == 0 && isShowApprovalBtn(data)">
        <van-col :span="12">
          <van-button round type="warning" block @click="handleApprove(2)">驳回</van-button>
        </van-col>
        <van-col :span="12">
          <van-button round type="info" block @click="handleApprove(1)">通过</van-button>
        </van-col>
      </van-row>
    </div>



    <van-dialog v-model="show" show-cancel-button close-on-click-overlay confirm-button-text="通过"
      cancel-button-text="取消" cancel-button-color="#000" confirm-button-color="#000"
      @confirm="auditType == 1 ? audit(1) : audit(2)">
      <div class="dialog-wrap">


        <div class="wrap" v-if="auditType === 2">
          <div class="title">您是否驳回？</div>
          <input type="text" class="remak" placeholder="驳回理由" v-model="remark" />
        </div>


        <div class="wrap" v-else>
          <div class="title">{{ dialogMsg }}</div>
          <div v-if="columns.length > 0">
            <div class="dialog-item-title">审批人</div>
            <div class="cell-wrap">
              <div class="cell-wrap_item" @click.stop="handelClickAudit(item, index)"
                v-for="(item, index) in nowAuditList" :key="item.id">
                <!-- 删除图标 -->

                <div class="audit_close" v-if="item.auditStatus == 0 && isShowClose(index)"
                  @click.stop="nowAuditList.splice(index, 1)">
                  <van-icon name="cross" />
                </div>

                <!-- 通过图标 -->
                <div class="audit_allow" v-if="item.auditStatus == 1">
                  <van-icon name="success" />
                </div>

                <img :src="item.avatar" alt="" />
                <span>{{ item.name }}</span>

              </div>


              <div class="cell-wrap_add" @click.stop="() => {
          nowAuditIndex = undefined;
          $refs.interviewee.showiIntervieweePopup = true
        }">
                <van-icon name="plus" />
              </div>
            </div>
          </div>
        </div>


      </div>
    </van-dialog>

    <van-popup v-model="showSelectPerson" round position="bottom" :style="{ height: '40%' }">
      <van-picker show-toolbar title="选择审批人" :columns="columns" @confirm="handleConfirm" ref="picker"
        @cancel="showSelectPerson = false" value-key="name" />
    </van-popup>
    <!-- 审批人选择弹窗 -->
    <Interviewee ref="interviewee" @selectItem="handleSelIntervieweeItem" pageType="teacher" />
  </div>
</template>
<script>
import { getDateYMD } from "@/utils";
import moment from "moment";
import { ImagePreview } from "vant";
import Interviewee from "@/components/subScribePopup/interviewee";

export default {
  components: {
    Interviewee,
  },
  data() {
    return {
      data: {},
      show: false,
      remark: "",
      auditType: "",
      personList: [],
      //审批通过需要的数据
      dialogMsg: "",
      showSelectPerson: false,
      columns: [],
      pickerItem: {},
      // 是否显示核酸板块
      nucleStatus: false,
      // 部门人员信息
      deptPersonList: [],
      // 审核步骤条测试数据
      // 当前审批人列表
      nowAuditList: [],
      nowAuditIndex: undefined
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
  },
  mounted() {
    console.log("预约通知query", this.$route.query);

    this.getSubDetail();
    this.getSysSchool()
    // this.getUserDeptListAll();
  },
  methods: {
    // 判断是否展示核酸区域
    async getSysSchool() {
      const { data, code, msg } = await this.$https.getSysSchool({
        // dictType: 'school_function_param',
        schoolId: localStorage.getItem("schoolId")
        // schoolId:"1070770900580810752"
      });
      if (code !== 200) {
        // this.$toast('')
        return;
      }
      // 核酸模块是否必填
      this.nucleStatus = data.some((item) => item.functionDictCode == 29);
    },
    // 点击获取同行人手机号
    getTeacherOrParentMobile(data, bol) {
      if (!data.noMobile) { // 没有手机号
        this.$https.getFollowMobile({
          id: data.id
        }).then(res => {
          if (res.code == 200) {
            data.noMobile = res.data
            data.isShowMobile = !bol

          } else {
            this.$toast(res.msg)
          }
        })
      } else { // 有手机号
        data.isShowMobile = !bol

      }
    },
    // 点击获取预约人手机号
    getMobile(data, bol) {
      if (!data.noMobile) { // 没有手机号
        this.$https.getVisitorMobile({
          id: data.id
        }).then(res => {
          if (res.code == 200) {
            data.noMobile = res.data
            data.isShowMobile = !bol

          } else {
            this.$toast(res.msg)
          }
        })
      } else { // 有手机号
        data.isShowMobile = !bol
      }
    },
    // 判断自己是否审批过
    isShowApprovalBtn(data) {
      let userId = this.$store.state.userId

      let personIndex = data.busAuditLevelList.findIndex(item => item.designatedPersonId == userId)


      if (personIndex != -1) {
        if (data.busAuditLevelList.length == 1 && data.busAuditLevelList[personIndex].auditStatus == 0) {
          return true
        } else {
          if (personIndex == 0) {
            if (data.busAuditLevelList[0].auditStatus == 0) {
              return true
            } else {
              return false
            }
          } else {
            if (data.busAuditLevelList[personIndex - 1].auditStatus == 1 && data.busAuditLevelList[personIndex].auditStatus == 0) {
              return true
            } else {
              return false
            }
          }

        }
      } else {
        return false
      }
    },
    // 判断是否能删除审核人
    isShowClose(index) {
      let newIndex = this.nowAuditList.findIndex(x => x.id == this.$store.state.userId)
      return index > newIndex
    },
    // 点击审批人进行审批人更换
    handelClickAudit(item, index) {
      // 当前审批人只能修改自己之后的审批人信息
      // 获取当前审核人在列表中的位置
      let newIndex = this.nowAuditList.findIndex(x => x.id == this.$store.state.userId)
      console.log('newIndex', index)
      if (index > newIndex) {
        this.nowAuditIndex = index
        this.$refs.interviewee.showiIntervieweePopup = true;
      }
    },



    handleSelIntervieweeItem(item) {
      console.log('item', item)
      // 判断有无当前审批人
      if (this.nowAuditList.some(x => x.id == item.id)) {
        this.$toast('当前审批人已存在，请勿重复添加')
        return
      }

      // 判断是添加还是修改人员
      if (this.nowAuditIndex == undefined) {
        this.nowAuditList.push({
          id: item.id,
          avatar: item.avatar,
          name: item.name,
          auditStatus: 0
        })
      } else {
        this.nowAuditList.splice(this.nowAuditIndex, 1, {
          id: item.id,
          avatar: item.avatar,
          name: item.name,
          auditStatus: 0
        })
      }



      this.pickerItem = item;
    },
    //获取下一个人批人列表
    async getUserDeptListAll() {
      const { data } = await this.$https.getUserDeptListAll({
        schoolId: this.$store.state.schoolId,
      });
      if (data.length == 0) {
        // this.$toast('搜索不到当前人员，请检查后重试')
        return false;
      }
      // 存储部门人员列表
      this.deptPersonList = data
      // this.searchNameList = data
      let filterData = data.filter(
        (item) => item.id !== this.$store.state.userId
      );
      let obj = {};
      filterData.forEach((item) => {
        if (!obj[item.deptName]) {
          obj[item.deptName] = [];
        }
        obj[item.deptName].push(item);
      });
      let columns = [];
      for (const key in obj) {
        columns.push({
          name: key,
          children: obj[key],
        });
      }
      this.columns = columns;
      console.log(columns);
    },
    //选择下一个审批人
    handleConfirm(value, indexs) {
      console.log(value, indexs, "vis详情");
      const columns1 = this.$refs.picker.getColumnValues(1);
      this.pickerItem = columns1[indexs[1]];
      this.showSelectPerson = false;
    },

    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl],
        closeOnPopstate: true,
      });
    },
    handleApprove(type) {
      this.show = true;
      this.auditType = type;
      this.dialogMsg = `${this.data.initiatorName} ${this.data.affiliatedUnit ? '(' + this.data.affiliatedUnit + ')' : ''}来访，您是否审核通过？`;
    },
    // 获取访客申请详情详情
    async getSubDetail() {
      await this.getUserDeptListAll()
      const { data, code } = await this.$https.getNoTokenDetail({
        visitorId: this.id,
      });
      if (code !== 200) {
        this.$toast("获取详情失败");
        return false;
      }
      data.isShowMobile = false

      this.data = data;
      // 审批数据时间和人名转化
      this.data.busAuditLevelList.forEach((item) => {
        let obj = this.deptPersonList.find((person) => person.id == item.designatedPersonId)
        item.name = obj.name
        item.avatar = obj.avatar
        item.createdTime = item.createdTime && moment(item.createdTime).format('YYYY-MM-DD HH:mm')
      })

      this.nowAuditList = JSON.parse(JSON.stringify(this.data.busAuditLevelList.map(item => {
        return {
          id: item.designatedPersonId,
          auditStatus: item.auditStatus,
          avatar: item.avatar,
          name: item.name
        }
      })))

      this.data.time = this.setVisitorTime(data.visitorBeginTime, data.visitorEndTime)
      // getDateYMD(data.visitorBeginTime) +
      // "-" +
      // moment(data.visitorEndTime).format("HH:mm");
      // 审批时间
      this.data.approvalTime = moment(data.createdTime).format(
        "YYYY-MM-DD HH:mm"
      );
      this.getPersonList(data.id);
    },

    // 设置预约时间
    setVisitorTime(start, end) {
      let startTime = moment(start).format('YYYY.MM.DD')
      let endTime = moment(end).format('YYYY.MM.DD')

      let startYear = moment(start).format('YYYY')
      let endYear = moment(end).format('YYYY')

      if (startTime == endTime) { // 同天审批
        return `${moment(start).format('YYYY.MM.DD HH:mm')} - ${moment(end).format('HH:mm')}`
      } else { // 跨天审批
        if (startYear == endYear) { //不跨年
          return `${moment(start).format('YYYY.MM.DD HH:mm')} - ${moment(end).format('MM.DD HH:mm')}`
        } else { // 跨年
          return `${moment(start).format('YYYY.MM.DD HH:mm')} - ${moment(end).format('YYYY.MM.DD HH:mm')}`
        }
      }
    },






    async getAuditList(type) {
      const { data, code, msg } = await this.$https.getAuditList({
        auditType: type,
        userId: this.$store.state.userId,
      });
      if (code !== 200) {
        this.$toast(msg);
        return false;
      }
      return Promise.resolve(data);
    },
    async audit(status) {
      if (status == 1) {
        this.$toast({
          type: "loading",
          message: "审批中...",
          overlay: true,
          duration: 0,
          forbidClick: true,
        });
      } else {
        this.$toast({
          type: "loading",
          message: "驳回中...",
          overlay: true,
          duration: 0,
          forbidClick: true,
        });
      }

      // console.log('待参数',{
      //   auditStatus: status,
      //   acceptId: this.$store.state.userId,
      //   visitorId: this.data.id,
      //   auditIds: status == 1 ? this.nowAuditList.map(item => item.id) : this.data.busAuditLevelList.map(x => x.designatedPersonId),
      //   remark: this.remark,
      // })
      // return 
      const { code, msg } = await this.$https.audit({
        auditStatus: status,
        acceptId: this.$store.state.userId,
        visitorId: this.data.id,
        auditIds: status == 1 ? this.nowAuditList.map(item => item.id) : this.data.busAuditLevelList.map(x => x.designatedPersonId),
        remark: this.remark,
      });
      if (code !== 200) {
        this.$toast(msg);
        // this.getAuditList(0);
        // this.getAuditList(1);
        return false;
      }
      if (status == 1) {
        // const res = await this.$https.getAuditStatus({
        //   visitId: this.data.id,
        // })
        // if (res.code !== 200) {
        //   this.$toast(res.msg)
        //   return
        // }
        this.$toast("审批通过");
        this.data.auditStatus = 1;
        this.getSubDetail();
      } else {
        this.$toast("驳回成功");
        this.data.auditStatus = 2;
        // 驳回成功后刷新当前页面
        this.getSubDetail();
      }
    },
    async getPersonList(id) {
      const { data, code } = await this.$https.getNoTokenPersonDetail({
        visitorId: id,
      });
      if (code !== 200) {
        this.$toast("获取人员失败");
        return false;
      }
      data.forEach(item => {
        item.isShowMobile = false
      })
      this.personList = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.border-b {
  border-bottom: 1px solid #f4f4f6;
}

.detail {
  padding-bottom: 10rem;
  padding-top: 1px;
}

.card {
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #fff;
  margin: 1rem;
  border-radius: 0.75rem;

  .title {
    color: rgba(120, 132, 158, 1);
    font-size: 0.75rem;
    padding: 1rem 1.25rem;
  }

  .panel {
    /* display: flex; */
    /* padding: 0rem 1rem 1rem 1rem; */
    margin: 0 1rem;
    padding-bottom: 1rem;

    /* align-items: center; */
    .img {
      width: 4.125rem;
      height: 4.125rem;
      border-radius: 50%;
      margin-right: 0.75rem;
      object-fit: cover;
    }

    .img_1 {
      width: 4.125rem;
      height: 4.125rem;
      border-radius: .5rem;
      margin-right: 0.75rem;
      object-fit: cover;
    }

    .info {
      flex: 1;

      .name {
        color: #454f63;
        font-size: 1.5rem;
        font-weight: bold;
      }

      .phone {
        color: #cad1e2;
        font-size: 0.875rem;
        margin-top: 0.25rem;
      }
    }

    .or {
      margin: 0.5rem 0;
      color: #78849e;
    }

    .center {
      text-align: center;
    }

    .time {
      font-size: 1rem;
      color: #78849e;
    }
  }

  .panel_1 {
    /* display: flex; */
    /* padding: 0rem 1rem 1rem 1rem; */
    margin: 0 1rem;
    padding-bottom: 1rem;

    /* align-items: center; */
    .img {
      width: 4.125rem;
      height: 4.125rem;
      border-radius: 50%;
      margin-right: 0.75rem;
      object-fit: cover;
    }

    .img_1 {
      width: 4rem;
      height: 4rem;
      border-radius: .5rem;
      margin-right: 0.75rem;
      object-fit: cover;
    }

    .info {
      flex: 1;

      .name {
        color: #454f63;
        font-size: 1.5rem;
        font-weight: bold;
      }

      .phone {
        color: #cad1e2;
        font-size: 0.875rem;
        margin-top: 0.25rem;
      }
    }

    .or {
      margin: 0.5rem 0;
      color: #78849e;
    }

    .center {
      text-align: center;
    }

    .time {
      font-size: 1rem;
      color: #78849e;
    }
  }
}

.cell {
  padding: 0.5rem 0;
  color: #454f63;
  font-size: 0.875rem;

  .headline {
    display: inline-block;
    color: #78849e;
    font-size: 0.75rem;

    margin-right: 1rem;
    width: 4rem;
    text-align: right;
  }
}

.btn-group {
  /* position: fixed; */
  width: 100%;
  margin-top: 2.5rem;

  /* left: 0; */
  .btn-wrap {
    padding: 0 2rem;
  }
}

.person-list {
  margin: 1rem 1rem 0;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #ffffff;
  border-radius: 0.75rem;

  .person-header {
    display: flex;
    justify-content: space-between;
    padding: 1rem 1.25rem;

    >span {
      color: rgba(120, 132, 158, 1);
      font-size: 0.75rem;
    }

    >div {
      .iconfont {
        font-size: 0.75rem;
      }

      font-size: 0.875rem;
      color: rgba(52, 151, 253, 1);
    }
  }

  .person-item {
    padding: 1rem 0;
    margin: 0 1rem;
    border-bottom: 1px solid rgba(244, 244, 246, 0.99);
    margin-bottom: 0.6rem;

    &:last-child {
      border-bottom: none;
    }

    .person-name {
      color: rgba(69, 79, 99, 1);
      font-size: 1rem;
      font-weight: 400;
      margin-bottom: 0.125rem;
    }

    .person-phone {
      color: rgba(120, 132, 158, 1);
      font-size: 0.875rem;
    }

    .person-avatar {
      margin-right: 1rem;

      img {
        width: 3rem;
        height: 3rem;
        border-radius: 0.75rem;
        margin: 0 auto;
        display: block;
        object-fit: cover;
      }
    }

    .handle {
      background: rgba(233, 235, 239, 1);
      border-radius: 0.5rem;
      font-size: 0.6875rem;
      width: 5rem;
      height: 2rem;
      text-align: center;
      line-height: 2rem;
      color: rgba(120, 132, 158, 1);
    }
  }
}

//通过理由输入框样式
.remark-input {
  background: #f7f7fa;
  border: none;
  padding: 10px 15px;
  width: 100%;
  border-radius: 20px;
  margin: 10px 0;
}

//选择下一个人批人样式
.dialog-item-title {
  //   color: #78849e;
  color: #333;
  //   font-size: 12px;
  margin: 10px 1rem;
}

.cell-wrap {
  padding: 10px 15px 0;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;

  .cell-wrap_item {
    // background-color: pink;
    margin-right: 1.8rem;
    margin-bottom: 1rem;
    display: flex;
    color: #c7c7c7;
    position: relative;
    align-items: center;
    flex-direction: column;

    .audit_close {
      position: absolute;
      top: 0;
      right: 0;
      width: 1rem;
      height: 1rem;
      text-align: center;
      line-height: 1rem;
      font-size: 0.6rem;
      background-color: #bac6d0;
      color: #fff;
      border-radius: 50%;
    }

    .audit_allow {
      position: absolute;
      top: 0;
      right: 0;
      width: 1rem;
      height: 1rem;
      text-align: center;
      line-height: 1rem;
      font-size: 0.6rem;
      background-color: #07c160;
      color: #fff;
      border-radius: 50%;
    }

    &::before {
      content: ". . .";
      position: absolute;
      color: #c7c7c7;
      height: 0.5rem;
      line-height: 0.1rem;
      top: 34%;
      transform: translateY(-50%);
      right: -1.5rem;
    }

    img {
      width: 4.4rem;
      height: 4.4rem;
      border-radius: 50%;
      background-color: #fff;
      margin-bottom: 0.3rem;
    }

    &:nth-child(3n) {
      margin-right: 0;
    }

    &:nth-child(3n)::before {
      color: transparent;
    }
  }

  .cell-wrap_add {
    width: 4.4rem;
    height: 4.4rem;
    border-radius: 50%;
    color: #c7c7c7
      /* 33/9.59 */
    ;
    margin-bottom: 1rem;
    line-height: 4.4rem;
    text-align: center;
    font-size: 1.8rem;
    border: 1px solid #c7c7c7;
  }
}

.dialog-wrap {

  .wrap {
    padding: 10px;
    display: flex;
    flex-direction: column;

    .title {
      text-align: center;
      margin: 1rem 0;
      //   color: red;
    }

    .remak {
      outline: none;
      border: none;
      background: #f7f7fa;
      padding: 10px 15px;
      border-radius: 30px;
      margin: 10px 0 20px 0;
    }
  }
}

// 步骤条的样式
.fail {
  color: #fff;
  background-color: #969799;
  border-radius: 50%;
}

.success {
  color: #fff;
  background-color: #07c160;
  border-radius: 50%;
}

.cross {
  background-color: red;
  border-radius: 50%;
  color: #fff;
}

.fail_text {
  color: #969799;
}

.success_text {
  color: #07c160;
}

.cross_text {
  color: red;
}
</style>
